import React, { useEffect } from 'react';

const services = [
  { title: 'Video Calls', desc: 'Private one-on-one video sessions tailored to you', icon: '📹', url: '/video-calls' },
  { title: 'Phone Calls', desc: 'Personal voice conversations for a deeper connection', icon: '📞', url: '/phone-calls' },
  { title: 'Sexting', desc: 'Flirty, intimate text-based sessions', icon: '💬', url: '/sexting' },
  { title: 'Custom Content', desc: 'Personalised photos and videos made just for you', icon: '📸', url: '/custom-content' },
  { title: 'Premade Content', desc: 'Browse my collection of premium photos and videos', icon: '🎥', url: '/content' },
  { title: 'Girlfriend Experience', desc: 'A genuine, ongoing virtual connection', icon: '💕', url: '/girlfriend-experience' },
  { title: 'Dick Ratings', desc: 'Honest, personalised ratings with detailed feedback', icon: '⭐', url: '/dick-ratings' },
  { title: 'Worn Items', desc: 'Personal worn items for a special connection', icon: '👙', url: '/worn-items' },
];

function Services() {
  useEffect(() => {
    document.title = 'Services | Izzie Fox - Independent UK Adult Content Creator';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b" style={{borderColor: '#EBBEDA'}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <a href="/" className="text-2xl font-bold" style={{color: '#EBBEDA'}}>Izzie Fox</a>
            <div className="flex items-center gap-6">
              <a href="/" className="text-gray-700 hover:text-pink-400 font-medium">Home</a>
              <a href="/#gallery" className="text-gray-700 hover:text-pink-400 font-medium">Gallery</a>
              <a href="/verify" className="text-gray-700 hover:text-pink-400 font-medium">Verification</a>
              <a href="/#contact" className="text-gray-700 hover:text-pink-400 font-medium">Contact</a>
              <a href="https://linktr.ee/IzzieFox" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-pink-400 font-medium">Linktree</a>
            </div>
          </div>
        </div>
      </nav>

      <section className="pt-24 pb-16" style={{background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 50%, #F5F0F6 100%)'}}>
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            My <span style={{color: '#EBBEDA'}}>Services</span>
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            I'm Izzie Fox, an independent UK adult content creator. Here's everything I offer — from private video calls and sexting to custom content and more. Message me to get started.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => (
              <a
                key={service.title}
                href={service.url}
                className="group rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 transform hover:-translate-y-2 block"
                style={{background: 'linear-gradient(135deg, #FAF8FB 0%, #FFFFFF 100%)', borderColor: '#EBBEDA'}}
                data-testid={`service-link-${service.url.slice(1)}`}
              >
                <div className="text-4xl mb-4">{service.icon}</div>
                <h2 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-pink-400 transition-colors">{service.title}</h2>
                <p className="text-gray-600 text-sm mb-4">{service.desc}</p>
                <span className="text-sm font-semibold" style={{color: '#EBBEDA'}}>Learn more →</span>
              </a>
            ))}
          </div>

          {/* Kink & Fetish Friendly Note */}
          <div className="mt-10 max-w-2xl mx-auto text-center bg-gradient-to-r from-pink-50 to-white rounded-2xl p-6 border-2 shadow-sm" style={{borderColor: '#EBBEDA'}}>
            <span className="text-2xl">🔥</span>
            <h3 className="text-lg font-bold text-gray-800 mt-2">Kink & Fetish Friendly</h3>
            <p className="text-gray-600 text-sm mt-2">I'm open-minded and non-judgemental. If you have specific interests or kinks you'd like to explore, feel free to message me and we can discuss what I'm able to accommodate.</p>
          </div>
        </div>
      </section>

      <footer className="bg-white border-t-2 py-6" style={{borderColor: '#EBBEDA'}}>
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-500 text-sm">
          <p><a href="/" className="font-bold text-gray-800">Izzie <span style={{color: '#EBBEDA'}}>Fox</span></a></p>
          <p className="mt-1">© 2026 Izzie Fox. All rights reserved. | 18+ Content | <a href="https://linktr.ee/IzzieFox" target="_blank" rel="noopener noreferrer" style={{color: '#EBBEDA'}}>Linktree</a></p>
        </div>
      </footer>
    </div>
  );
}

export default Services;
